import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import { usePublicConfig } from "../lib/consent";
import "../styles/privacy.css";

/** ลิงก์นโยบายและช่องทางติดต่อ แสดงท้ายทุกหน้าหลัก (สาธารณะ) เพื่อให้ผู้ใช้และผู้ตรวจสอบผู้ให้บริการชำระเงินเห็นเงื่อนไขได้ทุกหน้า */
/** ลิขสิทธิ์และลิงก์เว็บไซต์หลักของผู้ให้บริการ (AI Innovation) */
export function CopyrightLine() {
  const { t } = useI18n();
  return (
    <p className="small muted">
      {t("web.pol.footer.copy")}{" "}
      <a className="legal-link" href="https://ai-innovation.click" target="_blank" rel="noopener noreferrer">
        {t("web.pol.footer.main")}
      </a>
    </p>
  );
}

export function PolicyFooter() {
  const { t } = useI18n();
  const cfg = usePublicConfig();
  const email = cfg.data?.support_email?.trim();
  return (
    <footer className="policy-footer">
      <nav aria-label={t("web.pol.footer.nav")} className="policy-footer-nav">
        <Link className="legal-link" to="/policies">{t("web.pol.link")}</Link>
        <Link className="legal-link" to="/privacy">{t("web.priv.link")}</Link>
        <Link className="legal-link" to="/policies#terms">{t("web.pol.footer.terms")}</Link>
        <Link className="legal-link" to="/policies#refund">{t("web.pol.footer.refund")}</Link>
        <Link className="legal-link" to="/policies#contact">{t("web.pol.footer.contact")}</Link>
      </nav>
      {email && (
        <p className="small muted">
          <a className="legal-link" href={`mailto:${email}`}>{email}</a>
        </p>
      )}
      <CopyrightLine />
    </footer>
  );
}
